import React, { useState } from 'react';
import { ORG } from '../data/site';
import { Arrow } from './icons';

// There is no backend yet, so forms hand off to the visitor's email app
// with everything filled in. Swap `send` for an API call when one exists.
export default function MailForm({ fields, subject, submitLabel }) {
  const [sent, setSent] = useState(false);

  const send = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const body = fields.map((f) => `${f.label}: ${data.get(f.name) || '-'}`).join('\n');
    const subj = typeof subject === 'function' ? subject(data) : subject;
    window.location.href =
      `mailto:${ORG.email}?subject=${encodeURIComponent(subj)}&body=${encodeURIComponent(body)}`;
    setSent(true);
  };

  return (
    <form className="form" onSubmit={send}>
      {fields.map((f) => (
        <label key={f.name} className={`field${f.wide ? ' wide' : ''}`}>
          <span>{f.label}{f.required && <em aria-hidden="true"> *</em>}</span>
          {f.type === 'textarea' ? (
            <textarea name={f.name} rows={5} required={f.required} placeholder={f.placeholder} />
          ) : f.type === 'select' ? (
            <select name={f.name} required={f.required} defaultValue="">
              <option value="" disabled>Choose one</option>
              {f.options.map((o) => <option key={o}>{o}</option>)}
            </select>
          ) : (
            <input name={f.name} type={f.type || 'text'} required={f.required} placeholder={f.placeholder}
              autoComplete={f.autoComplete} />
          )}
        </label>
      ))}
      <div className="form-foot wide">
        <button className="pill pill-primary" type="submit">
          <span className="pill-fill" aria-hidden="true" />
          <span className="pill-label">{submitLabel}</span>
          <span className="pill-knob" aria-hidden="true"><Arrow /></span>
        </button>
        <p className="form-note" role="status">
          {sent
            ? <>Your email app should open with your message. If it doesn't, write to <a href={`mailto:${ORG.email}`}>{ORG.email}</a>.</>
            : 'This opens your email app with your message ready to send.'}
        </p>
      </div>
    </form>
  );
}
